export default {
    cn: {
        LP: {
            nav: [{
                    name: "TOP",
                    id: "nav-top"
                },
                {
                    name: "寄语",
                    id: "nav-message"
                },
                {
                    name: "体验",
                    id: "nav-expenrise"
                },
                {
                    name: "艺术家介绍",
                    id: "nav-artist"
                },
                {
                    name: "蒲公英的种植地",
                    id: "nav-place"
                },
                {
                    name: "大家制作的DANDELION",
                    id: "nav-result"
                },
                // {
                //     name: "植樹支援のお願い",
                //     id: "nav-contribution"
                // },
                {
                    name: "帮助",
                    id: "nav-supporters"
                },
                {
                    name: "咨询",
                    id: "nav-supporters"
                },
            ],
            top_desc_mb: "「DANDELION」是连接世界的艺术作品。\n\n对着蒲公英吹气，\n被吹起的绒毛满天飞舞，\n飞舞着飘越国界。\n飘落到世界各地，在全球各个地区设置的「DANDELION」作品旁开出许愿的花朵。\n\n全世界收集到的花朵，将会汇聚成美丽的花海。\n\n“希望世界和平”\n“希望世界变得更加美好”\n让你的愿望，随着你的绒毛一起，\n在全世界开花吧！",
            top_desc_pc: "「DANDELION」是连接世界的艺术作品。\n\n对着蒲公英吹气，\n被吹起的绒毛满天飞舞，飞舞着飘越国界。\n飘落到世界各地，在全球各个地区设置的「DANDELION」作品旁开出许愿的花朵。\n全世界收集到的花朵，将会汇聚成美丽的花海。\n\n“希望世界和平”\n“希望世界变得更加美好”\n让你的愿望，随着你的绒毛一起，在全世界开花吧！",
            msg: {
                msg_title: "寄语",
                msg_desc_mb: "2020年以来，整个世界都迎来了各种各样的变化，在这之变化之中，我们开始思考要如何与这个世界，与他人进行连结。\n\n在这个谁都拥有话语权，和任何人都可以随时进行沟通的时代。\n言语主义主张“一个正确性”来倾诉感情，但是这并不能概括全部。我们依然相信，可以通过一个和平，平稳的愿望，在温和的情感中拉近人与人的距离，连结人与人的心。\n\n「DANDELION」就是这样一个以简单形式连结世界各地所有人的作品。\n\n我非常喜欢这向蒲公英中注入愿景，吹散的瞬间。这个简单的体验。无论是谁小时候都做过的原始行为，并且带着所有人的愿景让世界各地都开满花来。",

                msg_desc_pc: "2020年以来，整个世界都迎来了各种各样的变化，在这之变化之中，我们开始思考要如何与这个世界，与他人进行连结。\n\n在这个谁都拥有话语权，和任何人都可以随时进行沟通的时代。\n言语主义主张“一个正确性”来倾诉感情，但是这并不能概括全部。我们依然相信，可以通过一个和平，平稳的愿望，在温和的情感中拉近人与人的距离，连结人与人的心。\n\n「DANDELION」就是这样一个以简单形式连结世界各地所有人的作品。\n\n我非常喜欢这向蒲公英中注入愿景，吹散的瞬间。这个简单的体验。无论是谁小时候都做过的原始行为，并且带着所有人的愿景让世界各地都开满花来。",
                msg_foot: "村松亮太郎 / NAKED"
            },
            art: {
                title1: "艺术家介绍",
                title2: "村松亮太郎 / NAKED",
                title3: "艺术家",
                desc1: "NAKED，INC的代表。1997年创立了创意型公司NAKED,INC以来，在影视、电视剧、MV、广告、空间创意、地方创生、教育计划种种领域中都十分活跃。",
                desc2: "NAKED，INC的代表。1997年创立了创意型公司NAKED,INC以来，在影视、电视剧、MV、广告、空间创意、地方创生、教育计划种种领域中都十分活跃。他导演的长篇/短片电影作品，在国际电影节上获得了48项提名，并获得多个奖项。近几年更是亲自策划了「FLOWERS BY NAKED」「TOKYO ART CITY BY NAKED」「TREE by NAKED」等等，沉浸式展览，餐厅，并把华道・茶道・香道・歌舞伎・能狂言这样的日本传统文化・技艺，和先进的表现手法相结合，打造出全新艺术演出。在大阪艺术大学担任特约教授的同时，作为总创意人以长野县・阿智村为中心，参与了大阪府・堺市，佐贺县等等日本各地的地方重造计划以及担当文化推广大使。从2018年开始以个人艺术家的身份进行创作，并在国内外展出了自己的作品。2019年，参与了在意大利・威尼斯，由轻井泽新艺术美术馆主办的「DIVERSITY FOR PEACE!」，参与了在中国・苏州举办的「SUZHOU DESIGN WEEK」。并且在香港的HQUSSENS的白石画廊首次开展个人艺术展「002」、在佳士得举办的「Christie‘s Autumn Auctions Hong Kong 2019」上，策划并制作了沉浸式招待晚宴。2020年在这个被疫情隔断的世界，着手策划了祈愿和平，以全新的形式链接世界的艺术作品「DANDELION PROJECT」，并且这件作品在正在向世界范围内扩大展出中。",
            },
            experrience: {
                text_title1: '大家一起来',
                text_title2_mb: "让只属于你的蒲公英\n飘向全世界吧",
                text_title2_pc: "让只属于你的蒲公英飘向全世界吧",
                text_btn: '体验',
                text_link: '打赏',
                text_desc: "你的打赏可以让\n「DANDELION」在更多地方扎根哦！",
            },
            result: {
                text_title1_mb: "大家制作的\nDANDELION",
                text_title1_pc: "大家制作的DANDELION",
                text_title2: "FRIENDS OF\nDANDELION PROJECT",
                text_desc: "在这里收集大家体验后的蒲公英，\n创造出全新的DANDELION",
                names: [{
                    firstName: "佐野光咲",
                    lastName: ""
                }, {
                    firstName: "佐野正騎",
                    lastName: ""
                }, {
                    firstName: "NOBU. MARUYAMA",
                    lastName: ""
                }, {
                    firstName: "JUN TERAYAMA",
                    lastName: ""
                }, {
                    firstName: "Ryuta Shimba",
                    lastName: ""
                }, {
                    firstName: "Shinsaku Nakagawa",
                    lastName: ""
                }, {
                    firstName: "Reiji Higashimaki",
                    lastName: ""
                }, {
                    firstName: "Erina",
                    lastName: ""
                }, {
                    firstName: "衞藤登喜子",
                    lastName: ""
                }, {
                    firstName: "深田しのぶ",
                    lastName: ""
                }, {
                    firstName: "小林優人",
                    lastName: ""
                }, {
                    firstName: "松田英樹",
                    lastName: ""
                }, {
                    firstName: "衞藤正和",
                    lastName: ""
                }, {
                    firstName: "衞藤弥保",
                    lastName: ""
                }]
            },
            placeText: {
                title: "蒲公英的种植地",
                desc_mb: "「DANDELION蒲公英」正在世界各地种植中",
                desc_pc: "「DANDELION蒲公英」正在世界各地种植中"
            },
            ctr: {
                title1: "给作品打赏吧",
                title2: "",
                desc1_mb: "「DANDELION PROJECT」是象征着世界和平、祈愿和平的作品，\n你的支持可以让「DANDELION」的种植计划到达更多地方。",
                desc1_pc: "「DANDELION PROJECT」是象征着世界和平、祈愿和平的作品，\n你的支持可以让「DANDELION」的种植计划到达更多地方。",
                desc2: "请从以下选择支持金额，然后单击“打賞”按钮。 ",
                btn1: "打赏",
                btn2: "",
                input_tips: "请自由输入金额",
                price_type: "USD$",
                safari_tips1: "※如果您使用的是 Safari，请参阅",
                safari_tips2: "此处的说明",
                safari_tips3: "。",
                safari_setting_tips: "如果您使用的是 Safari，请检查以下设置。\n设置> Safari> 弹出框> 关闭\n请设置。",
                min_money_tips: "※您可以从 0.5 美元进入。",
                law_tips: 'Specified Commercial Transaction Act',
                pay_urls: [{
                        name: "JP¥100",
                        url: "https://buy.stripe.com/4gw16J9ea1vN2IMdQS"
                    },
                    {
                        name: "JP¥500",
                        url: "https://buy.stripe.com/eVa02Fbmi5M31EI9AD"
                    }, {
                        name: "JP¥1,000",
                        url: "https://buy.stripe.com/00g02Fcqm1vNfvy7sw"
                    },
                    {
                        name: "JP¥10,000",
                        url: "https://buy.stripe.com/eVabLnfCy6Q7fvy7sx"
                    }
                ]

            },
            supportTitle: "帮助",
            contactTitle: "咨询",
            // OGP用情報
            ogp: {
                title: 'DANDELION PROJECT',
                description: '平和への祈りを、アートで繋ぐ。',
                type: 'website',
                url: 'www.breathbless.com',
                site_name: 'DANDELION PROJECT Official Site',
                image: '/Images/Ogp/OGP_breath.jpg',
                twitter_card: 'summary_large_image'
            },

            // タイトル
            title: 'Uniting Prayers for Peace',
            title_sp: 'Uniting' +
                '\r\n' +
                'Prayers' +
                '\r\n' +
                'for' +
                '\r\n' +
                'Peace',

            // サブタイトル
            subtitle: '平和への祈りを、アートで繋ぐ。',

            // ページの詳細
            description: 'これは、世界のあらゆる地点を結びながら、人々が参加することで成長するアート作品。\r\n' +
                '\r\n' +
                'たんぽぽの綿毛を飛ばすように、「Dandelion」に息を吹きかけると、\r\n' +
                'その綿毛は遠く離れた街へと舞い移り美しい花を咲かせます。\r\n' +
                '\r\n' +
                'さまざまな街から発せられる「Breath（吐息）」が、平和を願う「Bless（祈り）」の種となって世界へ。\r\n' +
                '\r\n' +
                'リアルとバーチャルがシンクロし、\r\n' +
                'ネットワークそのものが国境を越えるアートとして成長し続けます。',
            description_sp: 'これは、世界のあらゆる地点を結びながら、\r\n' +
                '人々が参加することで成長するアート作品。\r\n' +
                '\r\n' +
                'たんぽぽの綿毛を飛ばすように、「Dandelion」に息を吹きかけると、\r\n' +
                'その綿毛は遠く離れた街へと舞い移り美しい花を咲かせます。\r\n' +
                '\r\n' +
                'さまざまな街から発せられる「Breath（吐息）」が、\r\n' +
                '平和を願う「Bless（祈り）」の種となって世界へ。\r\n' +
                '\r\n' +
                'リアルとバーチャルがシンクロし、\r\n' +
                'ネットワークそのものが国境を越えるアートとして\r\n' +
                '成長し続けます。',

            // Send a Prayerボタンの接続先
            send_url: 'https://naked.co.jp/works/',

            title2: 'SEND A PRAYER',
            title2sp: 'SEND' +
                '\r\n' +
                'A' +
                '\r\n' +
                'PRAYER',
            subtitle2: 'あなたの平和への祈りで世界に花を咲かせましょう。',

            textcontents_qr: '今、『Dandelion』の近くにいる方',
            textcontents_qr_button: 'インタラクティブマーカー',

            textcontents_ol: 'オンラインから作品に参加される方',
            textcontents_ol_button: 'あなたの花を見つける',

            // Send a Prayerボタンから出るモーダルに表示される画像
            // send_modal_image: './Images/LP_dande_contents_0822.jpg',
            // send_modal_image_sp: './Images/LP_dande_SP-contents_0824.jpg',
            // send_modal_image_tb: './Images/LP_dande_ipad_0825.jpg',

            send_modal_image: './Images/maker_jp.jpg',
            // send_modal_image_sp: './Images/maker.jpg',
            // send_modal_image_tb: './Images/maker.jpg',

            // 会社ロゴ
            corporate_logo: './Images/NAKED,INC._Logotype_b.png',

            // 会社ロゴからの接続先
            corporate_url: 'https://naked.co.jp',

            // お問い合わせの接続先
            contact_url: 'https://naked.co.jp/contact/',

            // メッセージ
            //
            // thumbnail => サムネイル画像
            // title => タイトル
            // description => 詳細説明
            message: {
                thumbnail: './Images/RM.jpg',
                title: 'ARTIST',
                name: 'Ryotaro Muramatsu / NAKED ',
                description: 'アーティスト。NAKED, INC.代表。大阪芸術大学客員教授。長野県・阿智村ブランディングディレクター。 1997年にクリエイティブカンパニーNAKED, INC.を設立以来、映画やテレビ、MV、広告、空間演出など、ジャンルを超えてさまざまなプロジェクトを率いてきた。監督作品は長編/短編合わせて国際映画祭で48ノミネート&受賞。近年では「FLOWERS BY NAKED」「TOKYO ART CITY BY NAKED」などのイマーシブ(没入型)イベントや、華道・茶道・香道・歌舞伎・能狂言といった伝統文化・芸能と先進の表現を掛け合わせたインスタレーションや公演を手がける。大阪芸術大学で客員教授を務めるほか、ブランディング・ディレクターを務める長野県・阿智村をはじめ大阪府・堺市や佐賀県など日本各地での地方創生イベントや文化プロジェクトに取り組む。2018年には個人アーティストとしての創作活動を開始し、国内外で作品を発表してきた。',
                message: '2020年、この世界はさまざまな意味で大きく変わりました。' +
                    '\r\n' +
                    '不安の多い時期は続きそうですが、この経験が世界を分断するのではなく、むしろ新しいかたちで僕たちを結びつけるきっかけになって欲しいと感じています。' +
                    '\r\n' +
                    '\r\n' +
                    '人それぞれ異なるバックグラウンドを持っていますが、より良い世界になってほしいという思いは皆同じなのではないでしょうか。主義主張によって"一つの正しさ"を追求しようとすると終わりがありませんが、平和や平穏への祈りといった優しい感情を通して繋がり合う方法もあると信じたいです。' +
                    '\r\n' +
                    '\r\n' +
                    '「Dandelion」は、タンポポに息を吹きかけると舞い上がった綿毛が地面に根付き、新しい花を咲かせるインタラクティブ作品です。デジタルによって表現が拡張されるアートなのですが、タンポポに祈りを込めて吹くという、誰もが子供の頃に遊んだピュアな原体験的感覚を呼び起こすこの作品を、僕自身とても気に入っています。' +
                    '\r\n' +
                    '\r\n' +
                    '花は言葉を必要とせず、物事を分け隔てることもしません。' +
                    '\r\n' +
                    '種子を飛ばし、たどり着いた先でまた花を咲かせます。' +
                    '\r\n' +
                    'そんな風に、国や人種、思想に関わらず誰もが知っているシンプルな行為がアートとなって人々の祈りを繋げ、世界中に花を咲かせることができればと願っています。' +
                    '\r\n' +
                    '\r\n' +
                    '村松 亮太郎',
                message_sp: '『2020年、この世界はさまざまな意味で大きく変わりました。不安の多い時期は続きそうですが、この経験が世界を分断するのではなく、むしろ新しいかたちで僕たちを結びつけるきっかけになって欲しいと感じています。' +
                    '\r\n' +
                    '\r\n' +
                    '人それぞれ異なるバックグラウンドを持っていますが、より良い世界になってほしいという思いは皆同じなのではないでしょうか。主義主張によって"一つの正しさ"を追求しようとすると終わりがありませんが、平和や平穏への祈りといった優しい感情を通して繋がり合う方法もあると信じたいです。' +
                    '\r\n' +
                    '\r\n' +
                    '「Dandelion」は、タンポポに息を吹きかけると舞い上がった綿毛が地面に根付き、新しい花を咲かせるインタラクティブ作品です。デジタルによって表現が拡張されるアートなのですが、タンポポに祈りを込めて吹くという、誰もが子供の頃に遊んだピュアな原体験的感覚を呼び起こすこの作品を、僕自身とても気に入っています。' +
                    '\r\n' +
                    '\r\n' +
                    '花は言葉を必要とせず、物事を分け隔てることもしません。種子を飛ばし、たどり着いた先でまた花を咲かせます。' +
                    '\r\n' +
                    'そんな風に、国や人種、思想に関わらず誰もが知っているシンプルな行為がアートとなって人々の祈りを繋げ、世界中に花を咲かせることができればと願っています。』'
            },

            // サポーターのリンク
            //
            // logo => ロゴURL
            // url => リンク先URL
            supporters: [{
                    logo: './Images/Supporters/GB Logo SG_4C_Grey.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/sas.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/pds.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/tt.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/kddi.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_venice.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_tokyo.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_capetown.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/gl.png',
                    url: ''
                }
            ],

            // フレンドのリンク
            //
            // logo => ロゴURL
            // url => リンク先URL
            friends: [{
                    logo: './Images/Friends/friends_sanomisaki.png'
                },
                {
                    logo: './Images/Friends/friends_sanomasaki.png'
                },
                {
                    logo: './Images/Friends/friends_nobu.png'
                },
                {
                    logo: './Images/Friends/friends_jun.png'
                },
                {
                    logo: './Images/Friends/friends_ryuta.png'
                },
                {
                    logo: './Images/Friends/friends_shinsaku.png'
                },
                {
                    logo: './Images/Friends/friends_reiji.png'
                },
                {
                    logo: './Images/Friends/friends_erina.png'
                },
                {
                    logo: './Images/Friends/friends_etotokiko.png'
                },
                {
                    logo: './Images/Friends/friends_fukada.png'
                },
                {
                    logo: './Images/Friends/friends_kobayashi.png'
                },
                {
                    logo: './Images/Friends/friends_kuniya.png'
                },
                {
                    logo: './Images/Friends/friends_matsuda.png'
                },
                {
                    logo: './Images/Friends/friends_etomasakazu.png'
                },
                {
                    logo: './Images/Friends/friends_etomiho.png'
                },
            ],

            // 寄付のお願い
            contribution: {
                title_pc: '『Dandelion』植樹支援（作品設置支援）のお願い',
                title_sp: '『Dandelion』植樹支援（作品設置支援）のお願い',
                message: '「DANDELION PROJECT」は、平和への祈りのシンボルとなる『Dandelion』を' +
                    '\r\n' +
                    '世界各地に”植える(展示する)”ための支援金を募集しています。' +
                    '\r\n' +
                    '人々の想いを繋ぎ、世界中に花を咲かせる活動にぜひご参加ください。' +
                    '\r\n' +
                    '\r\n',
                message_sp: '「DANDELION PROJECT」は、' +
                    '\r\n' +
                    '平和への祈りのシンボルとなる『Dandelion』を' +
                    '\r\n' +
                    '世界各地に”植える(展示する)”ための' +
                    '\r\n' +
                    '支援金を募集しています。' +
                    '\r\n' +
                    '人々の想いを繋ぎ、世界中に花を咲かせる活動に' +
                    '\r\n' +
                    'ぜひご参加ください。' +
                    '\r\n' +
                    '\r\n',
                button: '植樹チケット',
                cloudfunding_abount: '',
                cloudfunding_description: '植樹チケット以外にも、様々な形でのご支援をお待ちしております。' +
                    '\r\n' +
                    '詳細は以下までお問い合わせください。',
                cloudfunding_description_sp: '植樹チケット以外にも、' +
                    '\r\n' +
                    '様々な形でのご支援をお待ちしております。' +
                    '\r\n' +
                    '詳細は以下までお問い合わせください。',
                cloudfunding_button: '支援に関するお問い合わせ',
                cloudfunding_image: './Images/cf_logo_padded.png',
                cloudfunding_url: 'https://camp-fire.jp/projects/view/314807'
            },

            // 各種SNSのリンク
            //
            // icon => アイコン
            // url => リンク先URL
            links: [{
                    icon: './Images/icon_facebook.png',
                    url: 'https://www.facebook.com/NAKEDINC.official/'
                },
                {
                    icon: './Images/icon_instagram.png',
                    url: 'https://www.instagram.com/naked_inc/'
                }
            ],
            place: [{
                    name_mb1: '日本・广岛',
                    name_mb2: '纸鹤塔',
                    image_mb: './Images/Place/mb/s00145.png',
                    name: '日本・广岛 / 纸鹤塔',
                    time: '2023.5.19 ー',
                    image: './Images/Place/s00145.png',
                    tips: '一般开放・需支付入场费',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '韩国·首尔',
                    name_mb2: '',
                    image_mb: './Images/Place/mb/s00178.png',
                    name: '韩国·首尔',
                    time: '2026.8.1 ー 2026.10.31',
                    image: './Images/Place/s00178.png',
                    tips: '一般开放・需支付入场费',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本·大阪',
                    name_mb2: 'VS.（位于 GRAND GREEN OSAKA 内）',
                    image_mb: './Images/Place/mb/s00177.png',
                    name: '日本·大阪 / VS.（位于 GRAND GREEN OSAKA 内）',
                    time: '2026.4.17 ー 2026.6.15',
                    image: './Images/Place/s00177.png',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://meets.naked.works/gaudi/'
                }, {
                    name_mb1: '台湾·台北',
                    name_mb2: '松烟文创区',
                    image_mb: './Images/Place/mb/s00176.png',
                    name: '台湾·台北 / 松烟文创区',
                    time: '2026.1.31 ー 2026.6.30',
                    image: './Images/Place/s00176.png',
                    tips: '一般开放',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・东京',
                    name_mb2: '寺田仓库',
                    image_mb: './Images/Place/mb/s00175.png',
                    name: '日本・东京 / 寺田仓库',
                    time: '2026.1.10 ー 2026.3.15',
                    image: './Images/Place/s00175.png',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://meets.naked.works/gaudi/'
                }, {
                    name_mb1: '日本・兵库',
                    name_mb2: '姬路城三之丸广场',
                    image_mb: './Images/Place/mb/s00174.png',
                    name: '日本・兵库 / 姬路城三之丸广场',
                    time: '2025.11.22 ー 2025.12.11',
                    image: './Images/Place/s00174.png',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'http://himeji-castle-dandelion.art/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '八坂神社',
                    image_mb: './Images/Place/mb/s00173.png',
                    name: '日本・京都 / 八坂神社',
                    time: '2025.8.8 ー 2025.8.17',
                    image: './Images/Place/s00173.png',
                    tips: '一般开放',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '伏见稻荷大社',
                    image_mb: './Images/Place/mb/s00172.png',
                    name: '日本・京都 / 伏见稻荷大社',
                    time: '2025.7.19 ー 2025.8.17',
                    image: './Images/Place/s00172.png',
                    tips: '一般开放',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・兵库',
                    name_mb2: '六甲高山植物园',
                    image_mb: './Images/Place/mb/s00171.png',
                    name: '日本・兵库 / 六甲高山植物园',
                    time: '2025.9.20 ー 2025.12.30',
                    image: './Images/Place/s00171.png',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://rokkomeetsart.jp/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '元离宫二条城',
                    image_mb: './Images/Place/mb/s00170.png',
                    name: '日本・京都 / 元离宫二条城',
                    time: '2025.3.14 ー 2025.4.13',
                    image: './Images/Place/s00170.png',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://event.naked.works/nijojo/spring/ja/'
                }, {
                    name_mb1: '中国・北京',
                    name_mb2: '遇见博物馆',
                    image_mb: './Images/Place/mb/s00168.png',
                    name: '中国・北京 / 遇见博物馆',
                    time: '2024.11.15 ー 2025.2.16',
                    image: './Images/Place/s00168.png',
                    tips: '一般开放・需支付入场费',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋贺',
                    name_mb2: '日吉大社（白山姬神社）',
                    image_mb: './Images/Place/mb/s00167.png',
                    name: '日本・滋贺 / 日吉大社（白山姬神社）',
                    time: '2024.11.1 ー 2024.12.8',
                    image: './Images/Place/s00167.png',
                    tips: '一般开放',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・石川',
                    name_mb2: '那谷寺',
                    image_mb: './Images/Place/mb/s00166.png',
                    name: '日本・石川 / 那谷寺',
                    time: '2024.10.25 ー 2024.11.24',
                    image: './Images/Place/s00166.png',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://yoru-sanpo.naked.works/natadera/'
                }, {
                    name_mb1: '日本・滋贺',
                    name_mb2: '比睿山延历寺坂堂',
                    image_mb: './Images/Place/mb/s00164.png',
                    name: '日本・滋贺 / 比睿山延历寺坂堂',
                    time: '2024.9.13 ー 2024.12.8',
                    image: './Images/Place/s00164.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋贺',
                    name_mb2: '彦根城',
                    image_mb: './Images/Place/mb/s00162.png',
                    name: '日本・滋贺 / 彦根城',
                    time: '2024.3.22 ー 2024.4.9',
                    image: './Images/Place/s00162.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                },
                // {
                //     name_mb1: '日本・大阪',
                //     name_mb2: '阿倍野 Harukas 观景台 \"Harukas 300\"',
                //     image_mb: './Images/Place/mb/s00157.png',
                //     name: '日本・大阪 / 阿倍野 Harukas 观景台 \"Harukas 300\"',
                //     time: '2023.11.28 ー 2024.3.31',
                //     image: './Images/Place/s00157.jpg',
                //     tips: '一般开放・需支付入场费',
                //     url_msg: '',
                //     url: 'https://ultraxperience.jp/0x0mugen-project/page_clf.html'
                // }, 
                {
                    name_mb1: '日本・大阪',
                    name_mb2: '万博纪念公园',
                    image_mb: './Images/Place/mb/s00156.png',
                    name: '日本・大阪 / 万博纪念公园',
                    time: '2023.12.1 ー 2023.12.25',
                    image: './Images/Place/s00156.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋贺',
                    name_mb2: '彦根城',
                    image_mb: './Images/Place/mb/s00155.png',
                    name: '日本・滋贺/彦根城',
                    time: '2023.11.11 ー 2023.12.9',
                    image: './Images/Place/s00155.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '元离宫二条城',
                    image_mb: './Images/Place/mb/s00144.png',
                    name: '日本・京都 / 元离宫二条城',
                    time: '2023.3.16 ー 2023.4.16',
                    image: './Images/Place/s00144.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・大阪',
                    name_mb2: 'W OSAKA',
                    image_mb: './Images/Place/mb/s00141.png',
                    name: '日本・大阪 / W OSAKA',
                    time: '2022.12.15 ー 2022.12.25',
                    image: './Images/Place/s00141.jpg',
                    tips: '一般开放',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '京都国立博物馆',
                    image_mb: './Images/Place/mb/s00136.png',
                    name: '日本・京都 / 京都国立博物馆',
                    time: '2022.12.10 ー 2022.12.25',
                    image: './Images/Place/s00136.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '仁和寺',
                    image_mb: './Images/Place/mb/s00135.png',
                    name: '日本・京都 / 仁和寺',
                    time: '2022.12.10 ー 2022.12.18',
                    image: './Images/Place/s00135.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: 'ACE HOTEL KYOTO',
                    image_mb: './Images/Place/mb/s00134.png',
                    name: '日本・京都 / ACE HOTEL KYOTO',
                    time: '2022.12.8 ー 2022.12.25',
                    image: './Images/Place/s00134.jpg',
                    tips: '一般开放',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '西本愿寺・唐门',
                    image_mb: './Images/Place/mb/s00133.png',
                    name: '日本・京都 / 西本愿寺・唐门',
                    time: '2022.11.24 ー 2022.11.27',
                    image: './Images/Place/s00133.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '平安神宫',
                    image_mb: './Images/Place/mb/s00132.png',
                    name: '日本・京都 / 平安神宫',
                    time: '2022.11.18 ー 2022.12.25',
                    image: './Images/Place/s00132.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '北野天满宫',
                    image_mb: './Images/Place/mb/s00131.png',
                    name: '日本・京都 / 北野天满宫',
                    time: '2022.11.12 ー 2022.11.27',
                    image: './Images/Place/s00131.jpg',
                    tips: '一般开放・与北野天满宫光影展一同开展',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・宇治',
                    name_mb2: '宇治市',
                    image_mb: './Images/Place/mb/s00130.png',
                    name: '日本・宇治 / 宇治市',
                    time: '2022.11.11 ー 2022.12.4',
                    image: './Images/Place/s00130.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・滋贺',
                    name_mb2: '彦根城',
                    image_mb: './Images/Place/mb/2022_10_dandelion_castle_fin_web.png',
                    name: '日本・滋贺/彦根城',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_castle_fin_web.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋贺',
                    name_mb2: '比叡山麓・滋贺院門跡',
                    image_mb: './Images/Place/mb/2022_10_dandelion_monseki_fin_web.png',
                    name: '日本・滋贺 / 比叡山麓・滋贺院門跡',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_monseki_fin_web.jpg',
                    tips: '一般开放（星期五 星期六 星期天 节日）・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '沙特阿拉伯・利雅得',
                    name_mb2: '阿尔穆拉瓦',
                    image_mb: './Images/Place/mb/2022_10_dandelion_almurabaa_fin_web.png',
                    name: '沙特阿拉伯・利雅得 / 阿尔穆拉瓦 ',
                    time: '2022.11.1 ー 2022.12.18',
                    image: './Images/Place/2022_10_dandelion_almurabaa_fin_web.jpg',
                    tips: '一般开放',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '元离宫二条城',
                    image_mb: './Images/Place/mb/2022_10_dandelion_nijojo_fin_web.png',
                    name: '日本・京都 / 元离宫二条城',
                    time: '2022.10.28 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_nijojo_fin_web.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '上贺茂神社',
                    image_mb: './Images/Place/mb/2022_09_dandelion_kamigamoshrine_fin_web.png',
                    name: '日本・京都 / 上贺茂神社',
                    time: '2022.10.21 ー 2022.10.23',
                    image: './Images/Place/2022_09_dandelion_kamigamoshrine_fin_web.jpg',
                    tips: '一般开放',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・大阪',
                    name_mb2: '梅北外苑SQUARE',
                    image_mb: './Images/Place/mb/2022_09_dandelion_square_fin_web.png',
                    name: '日本・大阪 / 梅北外苑SQUARE',
                    time: '2022.10.7 ー 2022.10.9',
                    image: './Images/Place/2022_09_dandelion_square_fin_web.jpg',
                    tips: '一般开放',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '旧三井家下鸭别府',
                    image_mb: './Images/Place/mb/2022_09_dandelion_oldmitsuifamily_fin_web.png',
                    name: '日本・京都 / 旧三井家下鸭别府',
                    time: '2022.9.23 ー 2022.10.2',
                    image: './Images/Place/2022_09_dandelion_oldmitsuifamily_fin_web.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '京都市政府前',
                    image_mb: './Images/Place/mb/2022_09_dandelion_shiyakusyo_fin_web.png',
                    name: '日本・京都 / 京都市政府前',
                    time: '2022.9.15 ー 2022.9.16',
                    image: './Images/Place/2022_09_dandelion_shiyakusyo_fin_web.jpg',
                    tips: '一般开放',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・滋贺',
                    name_mb2: '延历寺',
                    image_mb: './Images/Place/mb/2022_07_dandelion_hieizan_pers_fin_web.png',
                    name: '日本・滋贺 / 延历寺',
                    time: '2022.8.4 ー 2022.8.31',
                    image: './Images/Place/2022_07_dandelion_hieizan_pers_fin_web.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '平安神宫',
                    image_mb: './Images/Place/mb/2021_09_dande_heianjingu_fin_web.png',
                    name: '日本・京都 / 平安神宫',
                    time: '2021.12.15 ー 2022.1.16',
                    image: './Images/Place/2021_09_dande_heianjingu_fin_web.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '岚山',
                    image_mb: './Images/Place/mb/2021_09_dande_arashiyama_fin_web.png',
                    name: '日本・京都 / 岚山',
                    time: '2021.12.10 ー 2021.12.19',
                    image: './Images/Place/2021_09_dande_arashiyama_fin_web.jpg',
                    tips: '一般开放',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '兴圣寺',
                    image_mb: './Images/Place/mb/2021_10_dande_koushouji_fin_web.png',
                    name: '日本・京都 / 兴圣寺',
                    time: '2021.12.3 ー 2021.12.5',
                    image: './Images/Place/2021_10_dande_koushouji_fin_web.jpg',
                    tips: '一般开放・需夜间参拜费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・滋贺',
                    name_mb2: '彦根城',
                    image_mb: './Images/Place/mb/2021_11_dande_hikono_fin_web.png',
                    name: '日本・滋贺 / 彦根城',
                    time: '2021.11.27 ー 2022.1.30',
                    image: './Images/Place/2021_11_dande_hikono_fin_web.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・高知',
                    name_mb2: '高知城',
                    image_mb: './Images/Place/mb/2021_10_dande_kochijo_a4_fin_web.png',
                    name: '日本・高知 / 高知城',
                    time: '2021.11.19 ー 2022.01.10',
                    image: './Images/Place/2021_10_dande_kochijo_a4_fin_web.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://flowers.naked.works/kochi-castle/'
                },
                {
                    name_mb1: '日本・熊本',
                    name_mb2: '熊本城',
                    image_mb: './Images/Place/mb/2021_dande_kumamotojo_0928_fin_web.png',
                    name: '日本・熊本 / 熊本城',
                    time: '2021.11.19 ー 2021.12.05',
                    image: './Images/Place/2021_dande_kumamotojo_0928_fin_web.jpg',
                    tips: '一般开放',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '清水寺',
                    image_mb: './Images/Place/mb/2021_10_dande_kiyomizu_1011_fin_web.png',
                    name: '日本・京都 / 清水寺',
                    time: '2021.11.17',
                    image: './Images/Place/2021_10_dande_kiyomizu_1011_fin_web.jpg',
                    tips: '未一般开放',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '北野天满宫',
                    image_mb: './Images/Place/mb/2021_10_dande_kitanotenmangu3_1020_fin_web.png',
                    name: '日本・京都 / 北野天满宫',
                    time: '2021.11.13 ー 2021.11.14',
                    image: './Images/Place/2021_10_dande_kitanotenmangu3_1020_fin_web.jpg',
                    tips: '一般开放・与北野天满宫光影展一同开展',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '法国・巴黎',
                    name_mb2: '沙玛丽丹百货',
                    image_mb: './Images/Place/mb/2021_10_dande_pari_1025-3_web.png',
                    name: '法国・巴黎 / 沙玛丽丹百货',
                    time: '2021.11.8 ー 2021.11.20',
                    image: './Images/Place/2021_10_dande_pari_1025-3_web.jpg',
                    tips: '一般开放',
                    url_msg: '',
                    url: ''
                },


                {
                    name_mb1: '日本・京都',
                    name_mb2: '仁和寺',
                    image_mb: './Images/Place/mb/2021_10_dande_ninnaji_1011_fin_web.png',
                    name: '日本・京都 / 仁和寺',
                    time: '2021.11.2',
                    image: './Images/Place/2021_10_dande_ninnaji_1011_fin_web.jpg',
                    tips: '未一般开放',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '上贺茂神社',
                    image_mb: './Images/Place/mb/2021_09_dande_kamigamo_fin_web.png',
                    name: '日本・京都 / 上贺茂神社',
                    time: '2021.10.27',
                    image: './Images/Place/2021_09_dande_kamigamo_fin_web.jpg',
                    tips: '未一般开放',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・東京',
                    name_mb2: 'TBS',
                    image_mb: './Images/Place/mb/2021_10_dande_TVasa_0907-2_fin_web.png',
                    name: '日本・東京 / TBS',
                    time: '2021.10.1 ー 2021.10.31',
                    image: './Images/Place/2021_10_dande_TVasa_0907-2_fin_web.jpg',
                    tips: '一般开放',
                    url_msg: '',
                    url: ''


                },
                {
                    name_mb1: '日本・佐贺',
                    name_mb2: '佐贺县厅展望台大厅',
                    image_mb: './Images/Place/mb/2021_10_damde_saga_fin_web.png',
                    name: '日本・佐贺 / 佐贺县厅展望台大厅',
                    time: '2021.9.28 ー',
                    image: './Images/Place/2021_10_damde_saga_fin_web.jpg',
                    tips: '一般开放・需支付入场费',
                    url_msg: '详情点击这里',
                    url: 'https://garden.naked.works/saga/'


                },
                {
                    name_mb1: '日本・埼玉',
                    name_mb2: '姆明谷主题乐园',
                    image_mb: './Images/Place/mb/2020_11_dande_moomin_fin_web.png',
                    name: "日本・埼玉 / 姆明谷主题乐园",
                    time: "2020.11.21 ー 2021.03.07",
                    image: "./Images/Place/2020_11_dande_moomin_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・东京',
                    name_mb2: '涉谷区立宫下公园',
                    image_mb: './Images/Place/mb/2020_09_dande_miyashita_fin_web.png',
                    name: "日本・东京 / 涉谷区立宫下公园",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_miyashita_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '新加坡',
                    name_mb2: '滨海湾花园',
                    image_mb: './Images/Place/mb/2020_09_dande_singapore_fin_web.png',
                    name: "新加坡 / 滨海湾花园",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_singapore_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・东京',
                    name_mb2: '东京铁塔',
                    image_mb: './Images/Place/mb/2021_09_dande_tokyotower_a4_fin_web.png',
                    name: "日本・东京 / 东京铁塔",
                    time: "2020.11.09 ー",
                    image: "./Images/Place/2021_09_dande_tokyotower_a4_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                }
            ]
        }
    }
}